function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 32h32l-.5 2H0v-2zm0-8h32l-.5 2H0v-2zm0-8h32l-.5 2H0v-2zm0-8h32l-.5 2H0V8zm0-8h32l-.5 2H0V0z",
  fill: "#000"
});

function SvgMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTAgMzJoMzJsLS41IDJIMHYtMnpNMCAyNGgzMmwtLjUgMkgwdi0yek0wIDE2aDMybC0uNSAySDB2LTJ6TTAgOGgzMmwtLjUgMkgwVjh6TTAgMGgzMmwtLjUgMkgwVjB6IiBmaWxsPSIjMDAwIi8+Cjwvc3ZnPgo=";
export { SvgMenuIcon as ReactComponent };